import { render } from "./WorkOrder.vue?vue&type=template&id=7deef364"
import script from "./WorkOrder.vue?vue&type=script&lang=js"
export * from "./WorkOrder.vue?vue&type=script&lang=js"
script.render = render

export default script